export const NEW = 1;
export const OCCUPIED = 2;
export const CANCELLED = 3;
export const COMPLETED = 4;

export default Object.freeze({
  NEW,
  OCCUPIED,
  CANCELLED,
  COMPLETED
});
